// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZxRBS","largestCol":"styles_largestCol__3oQMm","smallestCol":"styles_smallestCol__2w9_o"};